import Image from "next/image";
import React, {ImgHTMLAttributes} from "react";
import {cn} from "@/lib/utils";

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
    poster: string;
    name: string
}

export default function GameCard({className, poster, name, sizes, ...props}: IProps) {
    return (
        <div className={cn('bg-gray aspect-video rounded-[8px] overflow-hidden border-2 border-stroke-gray flex justify-center items-center', className)}  {...props}>
            <div className={'relative w-[70%] h-[70%]'}>
                <Image
                    sizes={sizes}
                    fill
                    style={{
                        objectFit: 'contain',
                    }}
                    src={poster}
                    alt={name}
                />
            </div>
        </div>
    )
}
